import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../Navbar";
import TreatImage from "./TreatImage";
import { getSentTreat } from "../../services/treatApi";
import "../Pro/Pro.css";
import "./Treat.css";

// =====================================================
// TREAT SENT SUCCESSFULLY  (Step 5)  — /treat-sent/:treatId
//
// Reads the treat back from the server, so "successful" is what the server
// recorded, not what the checkout claimed.
// =====================================================

function TreatSent() {
  const { treatId } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    getSentTreat(treatId)
      .then((res) => setItem(res.item))
      .catch((err) => setError(err?.response?.data?.message || "Could not load this treat."));
  }, [treatId]);

  const paid = item?.paymentStatus === "paid";

  return (
    <div className="pro-page-wrap">
      <Navbar />
      <div className="pro-container pro-container-narrow">
        {!item && !error && (
          <div className="pro-loading-screen">
            <div className="pro-spinner" />
            <p>Confirming your payment…</p>
          </div>
        )}

        {error && (
          <div className="pro-card pro-empty">
            <p>{error}</p>
          </div>
        )}

        {item && (
          <div className="pro-card treat-confirm">
            <h1 className="pro-hero-title">{paid ? "Treat Sent Successfully" : "Payment is being confirmed"}</h1>
            <TreatImage image={item.treat.image} name={item.treat.name} icon={item.treat.icon} size={88} />
            <dl className="treat-confirm-list">
              <div><dt>Treat</dt><dd>{item.treat.name}</dd></div>
              <div><dt>Sent To</dt><dd>{item.blogger.name}</dd></div>
              <div><dt>Amount</dt><dd>Rs. {item.priceRupees}</dd></div>
              <div><dt>Transaction ID</dt><dd className="treat-mono">{item.transactionId}</dd></div>
            </dl>
            {!paid && (
              <p className="treat-dim">We'll update it in My Sent Treats as soon as Razorpay confirms the payment.</p>
            )}
            <div className="treat-actions">
              <button type="button" className="pro-btn pro-btn-ghost" onClick={() => navigate(`/blog/${item.blog._id}`)}>
                Back to the blog
              </button>
              <button type="button" className="pro-btn pro-btn-primary" onClick={() => navigate("/my-sent-treats")}>
                My Sent Treats
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TreatSent;
